export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 4_09.61d76111.jpg";